import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Link, useLocation, useNavigate } from 'react-router-dom';

import LoadingBox from '../../Component/LoadingBox';
import MessageBox from '../../Component/MessageBox';
import { register } from '../../redux/actions/userAction';
import Button from '../../Component/Button/index';

import './registerScreen.less';

export default function RegisterScreen() {
  const [name, setName] = useState(' ');
  const [email, setEmail] = useState(' ');
  const [password, setPassword] = useState(' ');
  const [confirmPassword, setConfirmPassword] = useState(' ');

  const userRegister = useSelector((state: any) => state.userRegister);

  const { userInfo, loading, error } = userRegister;

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const redirect = location.search
    ? Number(location.search.split('=')[1])
    : '/';

  const submitHandler = (e: React.FormEvent) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      alert('Password and confirm password are not match');
    } else {
      dispatch(register(name, email, password) as any);
    }
  };

  useEffect(() => {
    if (userInfo) {
      navigate(String(redirect));
    }
  }, [navigate, redirect, userInfo]);

  return (
    <div>
      <form className="register-form" onSubmit={submitHandler}>
        <div>
          <h1>Create Account</h1>
        </div>
        {loading && <LoadingBox></LoadingBox>}
        {error && <MessageBox variant="danger">{error}</MessageBox>}
        <div>
          <label htmlFor="email">Name</label>
          <input
            type="text"
            id="name"
            placeholder="Enter name"
            required
            onChange={e => setEmail(e.target.value)}
          />
        </div>
        <div>
          <label htmlFor="email">Email address</label>
          <input
            type="email"
            id="email"
            placeholder="Enter email"
            required
            onChange={e => setEmail(e.target.value)}
          />
        </div>

        <div>
          <label htmlFor="password">Password</label>
          <input
            type="password"
            id="password"
            placeholder="Enter password"
            required
            onChange={e => setPassword(e.target.value)}
          ></input>
        </div>
        <div>
          <label htmlFor="password">Confirm Password</label>
          <input
            type="password"
            id="password"
            placeholder="Enter confirm password"
            required
            onChange={e => setConfirmPassword(e.target.value)}
          ></input>
        </div>
        <div>
          <Button variant="primary">Register</Button>
        </div>
        <div>
          <div>
            Already have an account ?{' '}
            <Link to={`/signin ? redirect=${redirect}`}>Sign In</Link>
          </div>
        </div>
      </form>
    </div>
  );
}
